import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api, resolveImg } from "@/lib/api";
import { BookButton } from "@/components/site/BookButton";
import { Seo } from "@/components/site/Seo";

export default function ArticleDetail() {
  const { slug } = useParams();
  const [a, setA] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useEffect(() => {
    setA(null);
    api.get(`/articles/${slug}`).then((r) => setA(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return <div className="pt-48 text-center pb-40"><h1 className="font-serif text-4xl">Article not found</h1><Link to="/learn" className="link-underline mt-4 inline-block">Back to Learn</Link></div>;
  if (!a) return <div className="h-screen" />;

  return (
    <div>
      <Seo title={`${a.title} | Psalm 30:2 Chiropractic`} description={a.excerpt} />
      <article className="pt-36 lg:pt-44 pb-20 px-6">
        <div className="max-w-3xl mx-auto">
          <Link to="/learn" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-taupe hover:text-espresso mb-10" data-testid="article-back">
            <ArrowLeft size={15} /> Learn
          </Link>
          <div className="overline mb-5">{a.category}</div>
          <h1 className="font-serif font-light text-4xl lg:text-6xl leading-[1.05] text-espresso">{a.title}</h1>
          <div className="text-taupe text-sm mt-5">By {a.author}</div>
        </div>
        <div className="max-w-4xl mx-auto mt-12 overflow-hidden rounded-sm aspect-[16/8]">
          <img src={resolveImg(a.cover_image)} alt={a.title} className="w-full h-full object-cover" />
        </div>
        <div className="max-w-2xl mx-auto mt-14 prose-editorial text-lg font-light text-espressosoft/90">
          {(a.body || "").split("\n\n").map((p, i) => {
            const img = p.match(/^!\[(.*?)\]\((.+)\)$/);
            return img
              ? <img key={i} src={resolveImg(img[2])} alt={img[1] || a.title} className="w-full rounded-sm my-8" loading="lazy" data-testid={`article-inline-img-${i}`} />
              : <p key={i} className="whitespace-pre-line">{p}</p>;
          })}
        </div>
        <div className="max-w-2xl mx-auto mt-16 pt-10 border-t border-espresso/10 text-center">
          <BookButton label="Book a Visit" variant="primary" track_label={`article-${a.slug}`} testid="article-book-button" />
        </div>
      </article>
    </div>
  );
}
